import { render, staticRenderFns } from "./LatestPeriodical.vue?vue&type=template&id=5f88c7a8&scoped=true"
import script from "./LatestPeriodical.vue?vue&type=script&lang=js"
export * from "./LatestPeriodical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f88c7a8",
  null
  
)

export default component.exports